const zeroBalance = "Closed zero balance";
const virtueGuid = "406cb1e9-c4cf-475d-b272-472367d8d7fc";
const creditAccountsQueryMock = () => ({
  electronicConsent: true,
  accounts: [
    {
      info: {
        "cipher.accountId": "b5d38f4b-0a07-404d-a7c9-1851b58c7a39",
        accountIdType: "guid",
        accountLast4: "8876"
      },
      product: {
        lineOfBusiness: "RETAIL_CARD",
        portfolio: "Setpay",
        type: "DUAL_CARD",
        displayName: "Zetail Card RC"
      },
      registration: {
        eligibleForAutoRegistration: true,
        registered: true,
        registeredByVirtueOf: virtueGuid,
        transferable: true
      },
      servicing: {
        allowable: true,
        reason: zeroBalance
      }
    },
    {
      info: {
        "cipher.accountId": "i5k38m4g-0h0g-404g-h7jg-1851i58j7h3g",
        accountIdType: "guid",
        accountLast4: "5678"
      },
      product: {
        lineOfBusiness: "SETPAY",
        portfolio: "Home",
        type: "INSTALLMENT_LOAN_MONTHLY",
        displayName: "Installment Loaners"
      },
      registration: {
        eligibleForAutoRegistration: true,
        registered: true,
        registeredByVirtueOf: virtueGuid,
        transferable: true
      },
      servicing: {
        allowable: true,
        reason: zeroBalance
      }
    },
    {
      info: {
        "cipher.accountId": "2ec7be46-00f2-4367-9ef8-acb42e3a7ca3",
        accountIdType: "guid",
        accountLast4: "1531"
      },
      product: {
        lineOfBusiness: "SETPAY",
        portfolio: "Chevron",
        type: "INSTALLMENT_LOAN_PAY_IN_FOUR",
        displayName: "Pay in Four Loan Co"
      },
      registration: {
        eligibleForAutoRegistration: true,
        registered: true,
        registeredByVirtueOf: virtueGuid,
        transferable: true
      },
      servicing: {
        allowable: true,
        reason: zeroBalance
      }
    },
    {
      info: {
        "cipher.accountId": "2667sdft-04f3-4be3-96fc-47e954f5d45g",
        accountIdType: "guid",
        accountLast4: "4309"
      },
      product: {
        lineOfBusiness: "SETPAY",
        portfolio: "",
        type: "INSTALLMENT_LOAN_MONTHLY",
        displayName: "Monthly Product Type Waived interest expired"
      },
      registration: {
        eligibleForAutoRegistration: true,
        registered: true,
        registeredByVirtueOf: virtueGuid,
        transferable: true
      },
      servicing: {
        allowable: true,
        reason: zeroBalance
      }
    }
  ]
});
export { creditAccountsQueryMock as default };
//# sourceMappingURL=creditAccountsQueryMock.js.map
